import React from 'react';
import missions from '../data/mission.json';

function Missions(){
    return(
        <section id="mission">
            <div className="mission-page">
                <h3>Our Missions</h3>
                <div className="mission-list">
                    {
                        missions.map((mission, i) => (
                            <div className="mission-card" data-aos="fade-right" key={`${i}-mission`}>
                                <div className="mission-img">
                                    <img src={mission.image_path} alt={`${i}-mission`}></img>
                                </div>
                                    
                                <p>{mission.description}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </section>
    )
}

export default Missions